export default __webpack_public_path__ + "static/media/shirt-mockup-1.8b41c920.png";